import React, { useState } from 'react';
import { Button, Carousel } from 'react-bootstrap';
import { Link } from 'react-scroll';

import './header.css';

export default function Header() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel activeIndex={index} onSelect={handleSelect} indicators={false}>
      <Carousel.Item className='header-carousel-item'>
        <img className="d-block w-100" src="./images/header-01.jpg" alt="First slide" />
        <Carousel.Caption className="caption ">
          <h2 className="caption-title fade-in-title">Transform Your Outdoor Space</h2>
          <p className="caption-text fade-in-text">
            We create beautiful outdoor spaces that you'll love spending time in.
          </p>
          <Link to="services" spy={true} offset={-50}>
            <Button size="lg" className="caption-btn fade-in-btn">
              Explore Our Services
            </Button>
          </Link>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item className='header-carousel-item'>
        <img className="d-block w-100" src="./images/header-02.jpg" alt="Second slide" />
        <Carousel.Caption className="caption fade-in">
          <h2 className="caption-title fade-in-title">Expert Landscaping Services</h2>
          <p className="caption-text fade-in-text">
            Our team of experienced professionals has the skills and knowledge to create stunning landscapes that will make your property stand out.
          </p>
          <Link to="projects" spy={true} offset={-100}>
            <Button size="lg" className="caption-btn fade-in-btn">
              See our work
            </Button>
          </Link>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item className='header-carousel-item'>
        <img className="d-block w-100" src="./images/header-03.jpg" alt="Third slide" />
        <Carousel.Caption className="caption">
          <h2 className="caption-title fade-in-title">Get Your Dream Garden Today</h2>
          <p className="caption-text fade-in-text">
            Let us help you create the outdoor space of your dreams.
          </p>
          <Link to="contact" spy={true} offset={-100}>
            <Button size="lg" className="caption-btn fade-in-btn">
              Contact Us Today
            </Button>
          </Link>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}
